import { UserRole } from '../enums/UserRole';

const ROLE_APPLICATION: Record<UserRole, boolean> = {
  [UserRole.Admin]: true,
  [UserRole.Nutritionist]: true,
  [UserRole.User]: false,
};

/**
 * Whether accounts with this role belong to the dashboard application
 * (frontend-dashboard) rather than the consumer application (frontend).
 *
 * Single source of truth for the role → application mapping. Consumed by the
 * backend when choosing a password link's destination and by the dashboard
 * when building its route-guard role list.
 */
export function isDashboardRole(role: UserRole): boolean {
  return ROLE_APPLICATION[role];
}

/** Every role whose accounts belong to the dashboard. Derived, not hand-listed. */
export const DASHBOARD_ROLES: readonly UserRole[] = Object.values(UserRole).filter(
  isDashboardRole,
);
